import React,{Component} from 'react';

import Social from './Social';

import './NavigationMobile.less';


const NavigationMobile = ({menuItems, currentSection, goTo,isActive, showMenu, openAction,closeAction,res,data}) => (
    <div className="mobile-navigation">
      <div className='mobile-navigation-menu'></div>
      <div className='mobile-navigation-logo-container'>
        <img src="/img/logo.svg" className="mobile-navigation-logo" />
      </div>
      <div className={showMenu ? 'mobile-navigation-items visible': 'mobile-navigation-items'} style={{transform: showMenu ? 'translate3D(0,0,0)' : 'translate3D(0,-100%,0)'}}>
      {
        menuItems.map(item => {

          let href = '#';
          let active = false;

          if(item != 'Start'){
            href += item;
          }

          if(currentSection == href){
            active = true;
          }

          return <a key={href} href={href} className={active ? "active" : ""}  onClick={e => goTo(e)}>{item}</a>
        })
      }
        <Social style={{display: 'flex', width: '87.5%',opacity: showMenu ? 1 : 0}} mobile data={data}/>
      </div>
      {res && <div className={isActive ? `mobile-navigation-menuButton open` : `mobile-navigation-menuButton closed`} onClick={isActive ? closeAction : openAction}></div>}
    </div>
)

export default NavigationMobile



// WEBPACK FOOTER //
// ./src/components/NavigationMobile.js